import { Spin } from 'antd';

import useSidePanelTearouts from './utils/useSidePanelTearouts';

import { DesignSection } from '~/core/enums';
import { useGetDesignSectionTranslations } from '~/core/hooks/useGetDesignSectionTranslations';
import ItemCountAdjustButton from '~atoms/ItemCountAdjustButton';
import DesignStepContainer from '~molecules/DesignStepContainer';
import DesignSectionCard from '~organisms/DesignSectionCard';
import DesignSectionHeader from '~organisms/DesignSectionHeader';

const SidePanelTearoutsTab = () => {
  const {
    tearOuts,
    isFetchingOptionalItems,
    setAreaQtyOrDeselect,
    increaseSelectedTearOut,
    decreaseSelectedTearOut,
    setSelectedTearOutQty,
  } = useSidePanelTearouts();

  const { title, description } = useGetDesignSectionTranslations(
    DesignSection.TEAR_OUTS
  );

  return (
    <>
      <DesignSectionHeader title={title} description={description} />

      {isFetchingOptionalItems ? (
        <Spin style={{ fontSize: 24, marginLeft: '40%' }} />
      ) : (
        <DesignStepContainer>
          {tearOuts.map(([{ productId }, data]) => (
            <DesignSectionCard
              style={{ width: '100%' }}
              key={`tearout-${productId}`}
              title={data.title}
              image={data.image}
              isSelected={data.isSelected}
              onClick={setAreaQtyOrDeselect(productId)}
            >
              <p>{data.tearOutPrice}</p>
              <ItemCountAdjustButton
                quantity={data.isSelected ? data.quantity : undefined}
                onIncrease={increaseSelectedTearOut(productId)}
                onDecrease={decreaseSelectedTearOut(productId)}
                onUpdateValue={setSelectedTearOutQty(productId)}
              />
            </DesignSectionCard>
          ))}
        </DesignStepContainer>
      )}
    </>
  );
};

export default SidePanelTearoutsTab;
